import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectors, snackbar } from "../redux/snackbar";
import { Snackbar, CircularProgress } from "@mui/material";
import { Alert } from '@mui/material';

const anchorOrigin = { vertical: "bottom", horizontal: "right" };

export function SnackbarContainer() {
  const { snacks } = useSelector(selectors.get);
  const dispatch = useDispatch();

  return (
    <>
      {Object.keys(snacks).map((key) => {
        const item = snacks[key];
        const onClose = () => dispatch(snackbar.actions.remove(key));
        const { showCircularProgress, severity, message, alertProps = {}, autoHideDuration, ...restProps } = item;
        return (
          <Snackbar
            key={key}
            anchorOrigin={anchorOrigin}
            open
            onClose={onClose}
            children={
              <Alert
                icon={showCircularProgress ? <CircularProgress size={20} /> : undefined}
                onClose={onClose}
                severity={severity}
                elevation={12}
                children={message}
                {...alertProps}
              />
            }
            autoHideDuration={autoHideDuration}
            {...restProps}
          />
        );
      })}
    </>
  );
}
